import { FacilityWasteView } from "generated-graphql/graphql";

export const prettyPrintWasteViewType = (view: FacilityWasteView) => {
  switch (view) {
    case FacilityWasteView.All:
      return "All Waste";
    case FacilityWasteView.Reportable:
      return "Reportable Waste";
    case FacilityWasteView.NotReportable:
      return "Non Reportable Waste";
  }
};
